import { defineStore } from 'pinia';
import api from '../plugins/axios';
import { useAuthStore } from './auth';

export const useNotificationStore = defineStore('notifications', {
  state: () => ({
    notifications: [],
    unreadCount: 0,
    pollInterval: null,
  }),
  actions: {
    async fetchNotifications() {
      const authStore = useAuthStore();
      if (!authStore.isAuthenticated) return;
      
      try {
        const response = await api.get('/notifications');
        if (response.data?.status === 'success') {
          this.notifications = response.data.data.notifications.data || [];
          this.unreadCount = response.data.data.unread_count || 0;
        }
      } catch (error) {
        console.error('Failed to fetch notifications', error);
      }
    },
    
    async markAsRead(id = 'all') {
      try {
        const response = await api.post('/notifications/mark-read', { id });
        if (response.data?.status === 'success') {
          if (id === 'all') {
            this.unreadCount = 0;
            this.notifications.forEach(n => { n.read_at = new Date().toISOString(); });
          } else {
            const notif = this.notifications.find(n => n.id === id);
            if (notif) {
              notif.read_at = new Date().toISOString();
              this.unreadCount = Math.max(0, this.unreadCount - 1);
            }
          }
        }
      } catch (error) {
        console.error('Failed to mark notification as read', error);
      }
    },
    
    startPolling(intervalMs = 30000) {
      this.fetchNotifications();
      if (!this.pollInterval) {
        this.pollInterval = setInterval(() => {
          this.fetchNotifications();
        }, intervalMs);
      }
    },
    
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    }
  }
});
